import React from 'react';
import { SectionTypes } from '../../types';
import { SlotsPlaceholder } from '@wix/widget-plugins-ooi';
import { classes } from './Plugin.st.css';
import Section from '../Section';
import { SERVICE_PAGE_SLOT_ID } from '../../constants';

const Plugin: React.FC<{}> = () => {
  return (
    <Section sectionType={SectionTypes.PLUGIN}>
      <div className={classes.root}>
        <SlotsPlaceholder slotId={SERVICE_PAGE_SLOT_ID} />
      </div>
    </Section>
  );
};

export default Plugin;
